// JavaScript Document
$(document).ready(function() {

	/* task scroller in categorys */
	$(".categoryOverviewTasks, .tutorial").each( function() {
		var taskScrollWidth;
		var categoryLine = $(this);

		// overwrite  tasksPerLine if we using the tutorial slider
		if(categoryLine.hasClass('tutorial')) var tasksPerLine = 1;
		else var tasksPerLine = 3;

		var allTasks = categoryLine.find("ul li");

		// calculating new width for list and setting it
		var absoluteWidth = 0;
		allTasks.each(function() {
			absoluteWidth += $(this).outerWidth(true);
			taskScrollWidth = $(this).outerWidth(true) * tasksPerLine;
		});
		categoryLine.find("ul").width(absoluteWidth);

		// creating pager
		var countPages = Math.ceil(allTasks.length/tasksPerLine);
		if(countPages > 1) {
			pagingnationSection = categoryLine.find(".pagingnationSection");
			for(var i= 1; i <= countPages; i++) {
				pagingnationSection.append('<a>' + i + '</a>');
				pageLink = pagingnationSection.find("a:last");
				if(i == 1) pageLink.addClass("active");
				pageLink.click(function(){
					categoryLine.find(".pagingnationSection a").removeClass('active');
					$(this).addClass('active');
					categoryLine.find('ul').animate({
						marginLeft: -taskScrollWidth*($(this).text()-1)
					}, 500);
				})
			};
		}
	});


	/* make the hole hover-box on task in public area "clickable" to start the taskPlay
		getting all elements of the container manually because category link is different
		timeout before reload to show flash/gif loader on all browsers
	*/
	$(".hoverLiTP .toggleContainerHover, .hoverLiTP img, .hoverLiTP .hoverHeadline").click(function(event) {
		event.preventDefault();
		var redirectTask =  $(this).parents('.hoverLiTP').find('.hoverHeadline').find('a').attr('href');

		if (typeof redirectTask !== 'undefined') {
			// if task-enabled - show loader
			if ($(this).parents('.hoverLiTP.task-enabled').length) {
				if(showLoader(generalText[sys_language_uid]['start-task'])) {
					var t=setTimeout(function(){
						 window.location.href = redirectTask;
					},100);
				}
			} else {
				var t=setTimeout(function(){
					 window.location.href = redirectTask;
				},100);
			}
		}
	});


	/*  ...
	 */
	$("a.sticky_menu_98").click(function(event) {
		event.preventDefault();
		if(showLoader(generalText[sys_language_uid]['start-exam'])) {
			var redirectTask =  $(this).attr('href');
			var t=setTimeout(function(){
				window.location.href = redirectTask;
			},100);
		}
	});

	/* reform selects used in Category LIST View */
	$("#combobox_0").selectbox({effect: "slide", speed: 400});

	/* reform selects used on root page, sticky header breadcrumb */
	$("#combobox_5").selectbox({effect: "slide", speed: 400});

	/* reform selects used in Task NEW/EDIT View */
	$("#combobox_1").selectbox({effect: "slide", speed: 400});
	$("#combobox_1").next('div:first').click(function(){$("#combobox_1").click()}); //passthrough the click-event to the real selectbox, to ensure that the jquery validation error message disappear

	$("#combobox_2").selectbox({effect: "slide", speed: 400});
	$("#combobox_2").next('div:first').click(function(){$("#combobox_2").click()}); //passthrough the click-event to the real selectbox, to ensure that the jquery validation error message disappear

	$("#combobox_3").selectbox({effect: "slide", speed: 400});
	$("#combobox_3").next('div:first').click(function(){$("#combobox_3").click()}); //passthrough the click-event to the real selectbox, to ensure that the jquery validation error message disappear

	$("#combobox_4").selectbox({effect: "slide", speed: 400});
	$("#combobox_4").next('div:first').click(function(){$("#combobox_4").click()}); //passthrough the click-event to the real selectbox, to ensure that the jquery validation error message disappear

	/* reform selects used in registration process */
	$("#combobox_7").selectbox({effect: "slide", speed: 400});

	/* reform selects -not in use at the moment - */
	//$("#combobox_6").selectbox({effect: "slide", speed: 400});

	// resize select to length of current selected element
	$('.sbOptions a').each(function() {
		$(this).click(function() {
			var selectedOption = $(this);
			selectedOption.parents('.sbHolder').width(selectedOption.outerWidth(true)+40);
		});
	});

	// resizing the select
	$('.sbHolder').each(function() {
		var sbSelector = $(this).find('.sbSelector');
		$(this).width(sbSelector.outerWidth(true)+40);
	});


	/* reform checkboxes in answer form */
	$('#answerForm input:checkbox').uniform();


	/* reform upload fields in task new/edit view */
	$("#contentWrapper form input:file").each( function() {
		if($(this).attr('fileTitle')) var fileTitle =  generalText[sys_language_uid]['task-upload-file'] + $(this).attr('fileTitle');
		else var fileTitle = generalText[sys_language_uid]['task-upload-file-placeholder'];
		$(this).uniform({fileDefaultText: fileTitle, fileBtnText: generalText[sys_language_uid]['task-upload-file-button']});
	});


	/* handle section toggles in task new/edit view */
	$('.formTogglerAnswers').click(function() {
		$(this).toggleClass('show');
		$('#answerForm').fadeToggle();
	});

	/* show the tutorial, if cookie is not set */
	if(!getCookie('hideHomeWelcome')) {
		$('.welcomeWrapper').show();
	}

	/* show the news popUp, if cookie is not set */
	if(getCookie('hideNews')!=$('.popUpWrapper').attr('id')) {
		$('.popUpWrapper').css('display', 'block');
		setTimeout(function(){
			$('.popUpWrapper').animate({ "bottom": "0" }, "1000" );
		}, 1000);
	}

	/* handle welcome and tutorial on start screen */
	$('#closeWelcome').click(function()	{
		$(this).parents('.welcomeWrapper').slideUp(500);
		// setting cookie for never show tutorial again
		var expires = new Date();
		expires.setTime(expires.getTime() + (360 * 24 * 60 * 60 * 1000));
		document.cookie = "hideHomeWelcome=1; expires=" + expires.toGMTString();

	});

	/* handle welcome and tutorial on start screen */
	if ( $(".popUpWrapper").length) {
		$('.popUpClose').click(function(e)	{
			e.preventDefault();
			var height = $(this).parents('.popUpWrapper').height()+50;
			$(this).parents('.popUpWrapper').animate({ "bottom": "-"+height+"px" }, "500", function(){
				$(this).css('display', 'none');
			});
			// setting cookie for never show tutorial again

			//ausgeschaltet für Demozweck -> Bitte wieder aktivieren wenn Live
			var expires = new Date();
			expires.setTime(expires.getTime() + (360 * 24 * 60 * 60 * 1000));
			document.cookie = "hideNews="+$(this).parents('.popUpWrapper').attr('id')+"; expires=" + expires.toGMTString();
		});
	}


	$('#tutorialStart').click(function() {
		$('.tutorial').fadeIn(1000);
		$('.centerContent.welcomeWrapper').animate( { height:"560px" }, { queue:false, duration:500 });
		$('.welcome').fadeOut(1000);
	});

	/* fixing hovers for iPad */
	if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/iPad/i))) {
		// eigener titel für Homescreen
		document.title = "bewegunglesen";
		$("li.hoverLi").click(function(){//we just need to attach a click event listener to provoke iPhone/iPod/iPad's hover event, strange
		});
	}



});

/* Static functions */
// This functions reads & returns the cookie value of the specified cookie (by cookie name)
function getCookie(CookieName) {
	var CookieVal = null;
	if(document.cookie)	{
		var arr = document.cookie.split((escape(CookieName) + '='));
		if(arr.length >= 2) {
			var arr2 = arr[1].split(';');
			CookieVal  = unescape(arr2[0]); //unescape() : Decodes the String
		}
	}
	return CookieVal;
}

function showLoader(notice) {
	$('#page-loading-content p').html(notice);
	$('#page-loading').show();
	$('#page-loading-content').show();
	return true;
}

function showAnswers() {
	$('#answerForm').fadeToggle();
	$('.formTogglerAnswers').show();
}

function showAnswersFix() {
  $('#answerForm').fadeIn(500);
  $('.formTogglerAnswers').show();
}


